import { render, staticRenderFns } from "./BasePage.vue?vue&type=template&id=41e06c7c&scoped=true"
import script from "./BasePage.vue?vue&type=script&lang=js"
export * from "./BasePage.vue?vue&type=script&lang=js"
import style0 from "./BasePage.vue?vue&type=style&index=0&id=41e06c7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e06c7c",
  null
  
)

export default component.exports